export const DEFAULT_PAG = {
  limit: 10,
  page: 1
}

export const STATUS = {
  COMPLETED: 'COMPLETED',
  UNCOMPLETED: 'UNCOMPLETED'
}
